<template>  
  <div class="mb-3" :class="FormDataType.FieldSize">
    <b-form-group 
      :class="title_position"
      id="example text"
      :label-cols-lg="labels_lg"
      :label="FormDataType.FieldTitle" 
      label-for="text">
    
      <textarea 
        :class="{'is-invalid': v.$error}"  
        v-model="InputName" 
        @input="$emit('input', InputName)" 
        class="form-control" 
        :rows="rows"
        :disabled="FormDataType.Disabled"
        :maxlength="maxLength" 
      ></textarea>

      <!-- Sayaç kısmı sadece maxLength varsa gösterilsin -->
      <div v-if="sayac && maxLength" class="mt-2">
        <small class="text-muted">
          {{ currentLength }} / {{ maxLength }} karakter.
        </small>
        <small class="text-muted">
          Kalan karakter: {{ maxLength - currentLength }}
        </small>
      </div>

      <div v-if="v.$error" class="invalid-feedback">
        <span v-if="v.required == false"> {{ $t("ValidationMessage.required") }}</span>
        <span v-if="v.numeric == false">Bu Alan numeric.</span>
      </div>
    </b-form-group>  
  </div> 
</template> 

<script>  
export default {
  data() {
    return { 
      InputName: "",
      currentLength: 0,  // Kullanıcı tarafından girilen karakter sayısını tutar
    }
  },
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: String,
    title_position: String,
    labels_lg: Number,
    rows: null,
    sayac: { type: Boolean, default: false }, 
    maxLength: { type: Number, default: null }, 
  }, 
  watch: {
    FormPost() { 
      this.$v.$touch()
    },
    Value(){
      this.InputName = this.Value;
    },
    rows(){
      if (isNaN(this.rows)) {
        this.rows = 3;
      }
    },
    InputName() {
      this.currentLength = this.InputName.length;
    }
  },
  created() {  
    this.InputName = this.Value;
    this.currentLength = this.InputName.length; 
  }
};
</script>
